import BrokenGiftPreview from '../../../assets/broken-gift.svg';
import QrPlane from '../../../assets/tgs/auth/QrPlane.tgs';
import BannedDuck from '../../../assets/tgs/BannedDuck.tgs';
import BrokenGift from '../../../assets/tgs/BrokenGift.tgs';
import CameraFlip from '../../../assets/tgs/calls/CameraFlip.tgs';
import HandFilled from '../../../assets/tgs/calls/HandFilled.tgs';
import HandOutline from '../../../assets/tgs/calls/HandOutline.tgs';
import Speaker from '../../../assets/tgs/calls/Speaker.tgs';
import VoiceAllowTalk from '../../../assets/tgs/calls/VoiceAllowTalk.tgs';
import VoiceMini from '../../../assets/tgs/calls/VoiceMini.tgs';
import VoiceMuted from '../../../assets/tgs/calls/VoiceMuted.tgs';
import VoiceOutlined from '../../../assets/tgs/calls/VoiceOutlined.tgs';
import CraftProgress from '../../../assets/tgs/CraftProgress.tgs';
import Diamond from '../../../assets/tgs/Diamond.tgs';
import DuckNothingFound from '../../../assets/tgs/DuckNothingFound.tgs';
import Flame from '../../../assets/tgs/general/Flame.tgs';
import Fragment from '../../../assets/tgs/general/Fragment.tgs';
import Mention from '../../../assets/tgs/general/Mention.tgs';
import PartyPopper from '../../../assets/tgs/general/PartyPopper.tgs';
import PlayPause from '../../../assets/tgs/general/PlayPause.tgs';
import Invite from '../../../assets/tgs/invites/Invite.tgs';
import JoinRequest from '../../../assets/tgs/invites/Requests.tgs';
import LastSeen from '../../../assets/tgs/LastSeen.tgs';
import Eyes from '../../../assets/tgs/message/Eyes.tgs';
import Typing from '../../../assets/tgs/message/Typing.tgs';
import Writing from '../../../assets/tgs/message/Writing.tgs';
import MonkeyClose from '../../../assets/tgs/monkeys/TwoFactorSetupMonkeyClose.tgs';
import MonkeyIdle from '../../../assets/tgs/monkeys/TwoFactorSetupMonkeyIdle.tgs';
import MonkeyPeek from '../../../assets/tgs/monkeys/TwoFactorSetupMonkeyPeek.tgs';
import MonkeyTracking from '../../../assets/tgs/monkeys/TwoFactorSetupMonkeyTracking.tgs';
import ReadTime from '../../../assets/tgs/ReadTime.tgs';
import Report from '../../../assets/tgs/Report.tgs';
import Search from '../../../assets/tgs/Search.tgs';
import SearchingDuck from '../../../assets/tgs/SearchingDuck.tgs';
import Congratulations from '../../../assets/tgs/settings/Congratulations.tgs';
import DiscussionGroups from '../../../assets/tgs/settings/DiscussionGroupsDucks.tgs';
import DuckCake from '../../../assets/tgs/settings/DuckCake.tgs';
import Experimental from '../../../assets/tgs/settings/Experimental.tgs';
import FoldersAll from '../../../assets/tgs/settings/FoldersAll.tgs';
import FoldersNew from '../../../assets/tgs/settings/FoldersNew.tgs';
import FoldersShare from '../../../assets/tgs/settings/FoldersShare.tgs';
import HandStop from '../../../assets/tgs/settings/HandStop.tgs';
import Lock from '../../../assets/tgs/settings/Lock.tgs';
import Passkeys from '../../../assets/tgs/settings/Passkeys.tgs';
import UtyanDisappear from '../../../assets/tgs/settings/UtyanDisappear.tgs';
import StarReaction from '../../../assets/tgs/stars/StarReaction.tgs';
import StarReactionEffect from '../../../assets/tgs/stars/StarReactionEffect.tgs';
import Unlock from '../../../assets/tgs/Unlock.tgs';
import BlueDiamond from '../../../assets/tgs/wallet/BlueDiamond.tgs';
import Gram from '../../../assets/tgs/wallet/Gram.tgs';
import DuckNothingFoundPreview from '../../../assets/tgs-previews/DuckNothingFound.svg';
import WritingPreview from '../../../assets/tgs-previews/message/Writing.svg';
import PausePreview from '../../../assets/tgs-previews/Pause.svg';
import PlayPreview from '../../../assets/tgs-previews/Play.svg';
import SearchPreview from '../../../assets/tgs-previews/Search.svg';
import HandStopPreview from '../../../assets/tgs-previews/settings/HandStopPreview.png';
import PasskeysPreview from '../../../assets/tgs-previews/settings/Passkeys.svg';
import BlueDiamondPreview from '../../../assets/tgs-previews/wallet/BlueDiamond.svg';
import BlueDiamond3dPreview from '../../../assets/tgs-previews/wallet/BlueDiamond3d.webp';
import GramPreview from '../../../assets/tgs-previews/wallet/Gram.svg';
import Gram3dPreview from '../../../assets/tgs-previews/wallet/Gram3d.webp';

export const LOCAL_TGS_PREVIEW_URLS = {
  HandStop: HandStopPreview,
  PlayPause: PlayPreview,
  PlayPausePaused: PausePreview,
  BrokenGift: BrokenGiftPreview,
  DuckNothingFound: DuckNothingFoundPreview,
  Search: SearchPreview,
  Passkeys: PasskeysPreview,
  Writing: WritingPreview,
  BlueDiamond: BlueDiamondPreview,
  // The 3D model's first frame sits differently from the sticker's
  BlueDiamond3d: BlueDiamond3dPreview,
  Gram: GramPreview,
  Gram3d: Gram3dPreview,
};

export const LOCAL_TGS_URLS = {
  Gram,
  BlueDiamond,
  MonkeyIdle,
  MonkeyTracking,
  MonkeyClose,
  MonkeyPeek,
  FoldersAll,
  FoldersNew,
  FoldersShare,
  DiscussionGroups,
  Lock,
  CameraFlip,
  HandFilled,
  HandOutline,
  Speaker,
  VoiceAllowTalk,
  VoiceMini,
  VoiceMuted,
  VoiceOutlined,
  JoinRequest,
  Invite,
  QrPlane,
  Congratulations,
  Experimental,
  PartyPopper,
  PlayPause,
  Flame,
  ReadTime,
  Unlock,
  LastSeen,
  Mention,
  Fragment,
  StarReactionEffect,
  StarReaction,
  Report,
  SearchingDuck,
  BannedDuck,
  BrokenGift,
  CraftProgress,
  Diamond,
  Search,
  DuckNothingFound,
  Passkeys,
  UtyanDisappear,
  DuckCake,
  HandStop,
  Writing,
  Typing,
  Eyes,
};
